import {StackItem} from '../../interfaces/router/stackItem';
import screens from '../../config/screens';
import ForgetPassword from '../../screens/auth/forgetPassword';
import ResetPassword from '../../screens/auth/resetPassword';
import Login from '../../screens/auth/login';
import Register from '../../screens/auth/register';
import VerificationPending from '../../screens/auth/verificationPending';
import {createLazyComponent} from '../../utils/lazyLoad';

// Create lazy loaded components
const LazyForgetPassword = createLazyComponent(ForgetPassword);
const LazyResetPassword = createLazyComponent(ResetPassword);
const LazyLogin = createLazyComponent(Login);
const LazyRegister = createLazyComponent(Register);
const LazyVerificationPending = createLazyComponent(VerificationPending);

/**
 * An array of shared routes for a navigation stack.
 * @type {StackItem[]}
 */
const authRoutes: StackItem[] = [
  {
    name: screens.auth.login,
    component: LazyLogin,
    options: {
      headerShown: false,
      animation: 'fade',
    },
  },
  {
    name: screens.auth.register,
    component: LazyRegister,
    options: {
      headerShown: false,
    },
  },
  {
    name: screens.auth.forgetPassword,
    component: LazyForgetPassword,
    options: {
      headerShown: false,
    },
  },
  {
    name: screens.auth.resetPassword,
    component: LazyResetPassword,
    options: {
      headerShown: false,
    },
  },
  {
    name: screens.auth.verificationPending,
    component: LazyVerificationPending,
    options: {
      headerShown: false,
    },
  },
];

export default authRoutes;
